import React from "react";
import { Popover, PopoverInteractionKind } from "@blueprintjs/core";
import { Form } from "react-final-form";
import Button, { ButtonStyle } from "components/Button";
import TimingFields from "rs-components/TimingFields";
import { isFormValid } from "shared/validators";
import { DIALOG_ACTION_TITLE } from "shared/labels";
import * as styles from "./styles.module.scss";
const TimingDialog = ({ name, onClose, onSubmit, timestampOptions, timing, selectedVariable, restrictions, recipeId, }) => (React.createElement(Popover, { isOpen: true, onClose: onClose, hasBackdrop: true, content: React.createElement(Form, { onSubmit: onSubmit, initialValues: { [name]: timing }, render: ({ values, valid, active, errors, handleSubmit }) => (React.createElement("div", { className: styles.content },
            React.createElement(TimingFields, { label: "Point in time", name: name, values: values?.[name], additionalTimestampOptions: timestampOptions, restrictions: { [name]: restrictions }, excludedVariables: [selectedVariable], recipeIds: [recipeId] }),
            React.createElement("div", { className: styles["content-actions"] },
                React.createElement(Button, { onClick: onClose, style: ButtonStyle.Tertiary, label: DIALOG_ACTION_TITLE.CANCEL }),
                React.createElement(Button, { onClick: handleSubmit, disabled: !isFormValid({ valid, active, errors }), title: "", showTooltipIfDisabled: true, style: ButtonStyle.Primary, label: DIALOG_ACTION_TITLE.OK })))) }), portalClassName: styles.portal, className: styles.target, placement: "bottom-start", minimal: true, interactionKind: PopoverInteractionKind.CLICK, backdropProps: { className: styles.backdrop }, modifiers: {
        preventOverflow: {
            enabled: true,
            options: {
                padding: 10,
                altAxis: true,
            },
        },
        flip: {
            enabled: false,
        },
    } },
    React.createElement("div", null)));
export default TimingDialog;
